import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CREATE_CAMPAIGN_MANAGEMENT, CREATE_CAMPAIGN_MANAGEMENT_SUCCESS, CREATE_CAMPAIGN_MANAGEMENT_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* createCampaignManagement({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/campaigns`,
      method: 'POST',
      data: payload.data,
      isFormData: true,
      headers: {
        ...filteredHeaders,
      },
    });

    if (response.status === 200 || response.status === 201) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: CREATE_CAMPAIGN_MANAGEMENT_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CREATE_CAMPAIGN_MANAGEMENT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_CAMPAIGN_MANAGEMENT_ERROR, payload: error });
  }
}

export function* watchCreateCampaignManagement() {
  yield takeEvery(CREATE_CAMPAIGN_MANAGEMENT, createCampaignManagement);
}

function* createCampaignManagementSaga() {
  yield all([fork(watchCreateCampaignManagement)]);
}

export default createCampaignManagementSaga;
